import { DOAbnormalOperationUserBean } from "./do-abnormal-operation-user-bean";
import { DOAbnormalTableAbnormalItemData } from "./do-abnormal-table-abnormal-item-data";

export class DOAbnormalTableAbnormalItemSaveRequest extends DOAbnormalOperationUserBean {
  newDOAbnormalItems: DOAbnormalTableAbnormalItemData[];
  updatedDOAbnormalItems: DOAbnormalTableAbnormalItemData[];
  deletedDOAbnormalItemSeqNos: number[];

  constructor() {
    super();
    this.newDOAbnormalItems = [];
    this.updatedDOAbnormalItems = [];
    this.deletedDOAbnormalItemSeqNos = [];
  }
}
